<template>
  <VAlert color="warning">{{ $t('noIntegrations') }}</VAlert>
</template>

<script>
export default {
  name: 'IntegrationsListEmpty',
};
</script>

<style scoped>

</style>

<i18n locale="ru" lang="yml">
  noIntegrations: Для вашего региона нет доступных интеграций
</i18n>

<i18n locale="en" lang="yml">
  noIntegrations: No integrations for your region
</i18n>
